<template>
  <div
    class="hcl-dropdown dropdown"
    :class="{
      'hcl-dropdown-dropdown': props.type === 'dropdown',
      'hcl-dropdown-kebab': props.type === 'kebab'
    }"
    ref="refDropdown"
  >
    <button
      type="button"
      class="hcl-dropdown-button btn btn-link dropdown-toggle"
      :class="[classButtonClass]"
      :id="props.id"
      data-toggle="dropdown"
      data-boundary="window"
      :disabled="props.disabled"
      @click="toggleDropdown"
    >
      <template v-if="props.type === 'dropdown'">
        <template v-if="props.responsive">
          <i
            v-if="props.icon"
            class="hcl-dropdown-button-icon responsive-show"
            :class="props.icon"
          ></i>
          <span
            v-if="props.text"
            class="hcl-dropdown-button-text responsive-hide"
          >
            {{ props.text }}
          </span>
        </template>
        <template v-else>
          <i
            v-if="props.icon"
            class="hcl-dropdown-button-icon"
            :class="props.icon"
          ></i>
          <span
            v-if="props.text"
            class="hcl-dropdown-button-text"
          >
            {{ props.text }}
          </span>
        </template>
      </template>
      <template v-if="props.type === 'kebab'">
        <i class="eii--fa6-solid--ellipsis-vertical hcl-dropdown-kebab-icon "></i>
      </template>
    </button>
    <div
      class="hcl-dropdown-menu dropdown-menu"
      :class="[classDropdownRight, classDropdownClass]"
      :aria-labelledby="props.id"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { onClickOutside } from '@vueuse/core'

interface Props {
  type?: 'dropdown' | 'kebab'
  id?: string
  icon?: string
  text?: string
  disabled?: boolean
  responsive?: boolean
  buttonClass?: string,
  dropdownClass?: string,
  align?: string
}

const props = withDefaults(defineProps<Props>(), {
  type: 'dropdown',
  id: 'dropdown-1',
  icon: undefined,
  text: '',
  disabled: false,
  responsive: false,
  buttonClass: undefined,
  dropdownClass: undefined,
  align: 'right'
})

const refDropdown = ref()
const isDropdownOpen = ref(false)
const classButtonClass = ref(props.buttonClass ?? '')
const classDropdownClass = ref(props.dropdownClass ?? '')
const classDropdownRight = ref(props.align === 'right' ? 'dropdown-menu-right' : '')

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const closeDropdown = () => {
  isDropdownOpen.value = false
}

onClickOutside(refDropdown, () => closeDropdown())
</script>

<style lang="scss">
.hcl-dropdown {
  .hcl-dropdown-menu {
    .dropdown-item {
      i[class*='eii--']:not([class*=eii--stack]) {
        top: 0.125rem;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.hcl-dropdown {
  .hcl-dropdown-button {

    :not(:first-child):not(.responsive-hide) {
      margin-left: 0.5rem;
    }

    @media screen and (max-width: 767px) {
      .responsive-hide {
        display: none;
      }
    }

    @media screen and (min-width: 768px) {
      .responsive-show {
        display: none;
      }
    }
  }
}
</style>
